import React from 'react';

import FieldDesc from './FieldDesc';

import useFieldsIcons from '../hooks/useFieldsIcons';

export const FieldIcon = ({ field, value, ...props }) => {
  const fieldsIcons = useFieldsIcons().map(({ data }) => data);

  const current = fieldsIcons.find(({ Key }) => Key === field);

  if (!current) {
    return (
      <FieldDesc
        field={field}
        style={{ fontSize: '0.7rem', opacity: (value ? 1 : 0.15) }}
        {...props}
      />
    );
  }

  const { Picto: [
    { src: first } = {},
    { src: second } = {},
  ] } = current;

  return (
    value
      ? <img alt={`${field} : oui`} src={first?.publicURL} />
      : <img alt={`${field} : non`} src={second?.publicURL} />
  );
};

export default FieldIcon;
